import React from "react"
import propTypes from "prop-types"

const Hamburger = (props) => {
  return (
    <svg
      viewBox="0 0 24 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="header-icon-body"
    >
      <title>np_menu_1807506_000000</title>
      <defs>
        <filter>
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.992157 0 0 0 0 0.984314 0 0 0 0 0.929412 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none">
        <g transform="translate(-35.000000, -61.000000)">
          <g transform="translate(0.000000, 32.000000)">
            <g transform="translate(35.000000, 29.000000)">
              <path
                d="M0,0 L0,3.125 L24.375,3.125 L24.375,0 L0,0 Z M0,8.4375 L0,11.5625 L24.375,11.5625 L24.375,8.4375 L0,8.4375 Z M0,16.875 L0,20 L24.375,20 L24.375,16.875 L0,16.875 Z"
                fill={props.fill}
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Hamburger

Hamburger.propTypes = {
  fill: propTypes.string.isRequired,
}
